import { render } from "./BrowserArtboard.vue?vue&type=template&id=9fe7c070"
import script from "./BrowserArtboard.vue?vue&type=script&lang=js"
export * from "./BrowserArtboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__